import {
  DisplayFieldsModel,
  OnComplexSettingsModel,
  SiteSettingsModel,
} from "src/app/api/api-types";
import {
  DisplayColumnsPreferences,
  DisplayColumnsPreferencesKey,
} from "./display-columns-preferences.model";

import { DriverInformationSettings } from "./driver-information-settings.model";

export class SitePreferences {
  public constructor(args: ClassProperties<SitePreferences>) {
    this.completedMoveRequestPreferences = args.completedMoveRequestPreferences;
    this.dockActivityPreferences = args.dockActivityPreferences;
    this.driverInformationSettings = args.driverInformationSettings;
    this.dropTrailerPreferences = args.dropTrailerPreferences;
    this.isDropTrailerListHidden = args.isDropTrailerListHidden;
    this.onComplexPreferences = args.onComplexPreferences;
  }

  public readonly completedMoveRequestPreferences: DisplayColumnsPreferences<DisplayColumnsPreferencesKey.COMPLETED_MOVE_REQUEST>;
  public readonly dockActivityPreferences: DisplayColumnsPreferences<DisplayColumnsPreferencesKey.DOCK_ACTIVITY>;
  public readonly driverInformationSettings: DriverInformationSettings;
  public readonly dropTrailerPreferences: DisplayColumnsPreferences<DisplayColumnsPreferencesKey.DROP_TRAILER>;
  public readonly isDropTrailerListHidden: boolean;
  public readonly onComplexPreferences: DisplayColumnsPreferences<DisplayColumnsPreferencesKey.ON_COMPLEX>;

  public static deserialize({
    sitePreferences,
    hideDropTrailerList,
    onComplexSettings,
  }: {
    onComplexSettings: OnComplexSettingsModel;
    sitePreferences: SiteSettingsModel["sitePreferences"];
    hideDropTrailerList: SiteSettingsModel["hideDropTrailerList"];
  }): SitePreferences {
    return new SitePreferences({
      onComplexPreferences: DisplayColumnsPreferences.deserialize(
        sitePreferences,
        DisplayColumnsPreferencesKey.ON_COMPLEX,
      ),
      dockActivityPreferences: DisplayColumnsPreferences.deserialize(
        sitePreferences,
        DisplayColumnsPreferencesKey.DOCK_ACTIVITY,
      ),
      dropTrailerPreferences: DisplayColumnsPreferences.deserialize(
        sitePreferences,
        DisplayColumnsPreferencesKey.DROP_TRAILER,
      ),
      completedMoveRequestPreferences: DisplayColumnsPreferences.deserialize(
        sitePreferences,
        DisplayColumnsPreferencesKey.COMPLETED_MOVE_REQUEST,
      ),
      driverInformationSettings:
        DriverInformationSettings.deserialize(onComplexSettings),
      isDropTrailerListHidden: hideDropTrailerList,
    });
  }

  public serialize(preferences: SitePreferences): DisplayFieldsModel {
    const {
      completedMoveRequestCustomDisplayColumns,
      completedMoveRequestDefaultDisplayColumns,
    } = preferences.completedMoveRequestPreferences.serialize(
      DisplayColumnsPreferencesKey.COMPLETED_MOVE_REQUEST,
    );

    const { dashboardCustomDisplayColumns, dashboardDefaultDisplayColumns } =
      preferences.onComplexPreferences.serialize(
        DisplayColumnsPreferencesKey.ON_COMPLEX,
      );

    const {
      dockActivityCustomDisplayColumns,
      dockActivityDefaultDisplayColumns,
    } = preferences.dockActivityPreferences.serialize(
      DisplayColumnsPreferencesKey.DOCK_ACTIVITY,
    );

    const {
      dropTrailerCustomDisplayColumns,
      dropTrailerDefaultDisplayColumns,
    } = preferences.dropTrailerPreferences.serialize(
      DisplayColumnsPreferencesKey.DROP_TRAILER,
    );

    return {
      ...preferences.driverInformationSettings.serialize(),
      hideDropTrailerList: preferences.isDropTrailerListHidden,
      sitePreferences: {
        completedMoveRequestCustomDisplayColumns,
        completedMoveRequestDefaultDisplayColumns,
        dashboardCustomDisplayColumns,
        dashboardDefaultDisplayColumns,
        dockActivityCustomDisplayColumns,
        dockActivityDefaultDisplayColumns,
        dropTrailerCustomDisplayColumns,
        dropTrailerDefaultDisplayColumns,
      },
    };
  }
}
